import {Button, Card, CardContent, CardHeader, CardTitle} from 'alm-react-components';
import SaveIcon from '../../../assets/images/svgicons/save.svg';
import UnsaveIcon from '../../../assets/images/svgicons/unsave.svg';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import BookIcon from '../../../assets/images/svgicons/book.svg';
import {useNavigate, useParams} from 'react-router-dom';
import useLibrarySeeAll from '../../../hooks/useLibrarySeeAll';
import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import {apis} from '../../../services/alm';
import {defaultImage, LibraryFilteration} from '../../../lib/utils';
import {useTranslation} from 'react-i18next';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import {ActionType, APPROUTES, constants, DateFormat, Tag} from '../../../assets/constants/constants';
import useGetEnrolled from '../../../hooks/useGetEnrolled';
import PageLoader from '../../common/loader/PageLoader';
import { AppContext } from '../../../context/AppProvider';
import moment from 'moment-timezone';

const Books = () => {
  const [booksData, setBooksData] = useState([]);
  const {bookMarkresponse, deleteBookMark, addBookMark} = useLibrarySeeAll();
  const {id} = useParams();
  const {tagsData}=useGetEnrolled()
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {dispatch } = useContext(AppContext);


  const [loading, setLoading] = useState(true);

  const getBooksData = async () => {
    try {
      const result = await apis.fetchContentByCatalogIdForLibrary(id);
      const data = LibraryFilteration(tagsData, result?.data)
      setBooksData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    getBooksData().finally(() => {
      setLoading(false);
    });
  }, [bookMarkresponse, id]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div>
        <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
          <div className="flex justify-between items-center pl-2">
            <Button
              onClick={() => {dispatch({ type: ActionType.SET_KEYWORD, payload:"" });navigate(APPROUTES.library)}}
              variant="default"
              className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
            >
              <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
            </Button>
          </div>
          <h2 className="text-3xl font-barlowLight mt-6 pl-2">
          <span dangerouslySetInnerHTML={{ __html: (t('Library.myBooks')) }} /></h2>
          {loading ? (
            <div className="flex justify-center items-center h-[calc(100vh-32rem)] w-full">
              <PageLoader />
            </div>
          ) : (
            <div className="flex -ml-4 lg:flex-row md:flex md:flex-row flex-wrap gap-y-6 mt-12 px-2">
              {booksData?.length > 0 &&
                booksData?.map((res: any) => {
                const content = getLocalizedContent(res?.attributes?.localizedMetadata);
                  const releaseDate = res?.attributes?.tags
                  ?.filter((item: any) => item?.split(':')[0] === Tag.releaseDate)[0]
                  ?.split(':')[1];
                  return (
                    <>
                      <div className="min-w-0 shrink-0 grow-0 basis-full pl-4 landscape:2xl:basis-1/4 landscape:xl:basis-1/3 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                        <Card
                          onClick={() =>
                            navigate(
                           `/home/library/library-course/${res?.id}?catId=${id}`,{state:{courseType:encodeURIComponent(constants.BOOKS), filterTag:constants.BOOKS,filterationTag:constants.BOOKS,from:APPROUTES.library}}
                            )
                          }
                          className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative"
                        >
                          <CardHeader className="p-0">
                            <div className={`relative cursor-pointer]`}>
                              {res?.attributes?.imageUrl ? (
                                <img
                                  src={res?.attributes?.imageUrl}
                                alt={' '}
                                  className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                                />
                              ) : (
                                <img
                                  src={defaultImage()}
                                alt={' '}
                                  className="rounded-t-xl w-full h-full aspect-[3/2] object-cover"
                                />
                              )}
                            <img src={BookIcon} alt={' '} className="absolute center-icon" />
                            </div>
                          </CardHeader>
                          <CardContent className="mt-4 px-5">
                            <div className="flex flex-row items-start justify-between mt-2 h-full">
                              <div className="flex flex-col justify-between">
                                <div className="flex flex-col">
                                  <CardTitle className="text-wrap text-2xl font-barlowMedium">
                                    {content?.name}
                                  </CardTitle>
                                  <p className="text-lg font-opensansRegular mt-2 mb-16 flex-grow">
                                    {content?.description}
                                  </p>
                                </div>
                                <p className="text-base font-opensansMedium absolute bottom-6">
                                {/* {formatDate(releaseDate?releaseDate:"")} */}
                                <span className="capitalize">
                                  {releaseDate && moment(releaseDate).isValid() ? moment(releaseDate).format(DateFormat) : ""}
                                </span>
                                </p>
                              </div>
                              <img
                                onClick={(e) => {
                                  e.stopPropagation(); // Prevent the event from propagating to the parent elements
                                  if (res.attributes?.isBookmarked) {
                                    deleteBookMark(res?.id); // Call deleteBookMark if it's bookmarked
                                  } else {
                                    addBookMark(res?.id); // Call addBookMark if it's not bookmarked
                                  }
                                }}
                              src={res?.attributes?.isBookmarked ? SaveIcon : UnsaveIcon}
                                alt="No image"
                                className="ms-5 cursor-pointer"
                              />
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                    </>
                  );
                })}
            </div>
          )}
          {booksData?.length < 1 && (
            <div className=" flex w-full justify-center text-2xl">
              <span dangerouslySetInnerHTML={{ __html: (t('Library.noBooksAvailable')) }} /> 
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Books;
